import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/insights/newsletters/")({
  beforeLoad: () => {
    throw redirect({ to: "/admin/newsletter/newsletters" });
  },
});
